export const categories = [
  {
    slug: 'goals',
    name: '进球纪录',
    icon: 'ri-football-line',
    description: '郝海东职业生涯全部进球数据统计与分析',
    color: 'primary',
  },
  {
    slug: 'national-team',
    name: '国家队生涯',
    icon: 'ri-flag-line',
    description: '代表中国国家队征战的完整记录',
    color: 'accent',
  },
  {
    slug: 'dalian-shide',
    name: '大连实德',
    icon: 'ri-building-line',
    description: '在大连实德俱乐部的辉煌岁月',
    color: 'primary',
  },
  {
    slug: 'controversy',
    name: '争议事件',
    icon: 'ri-flashlight-line',
    description: '职业生涯中的争议与讨论',
    color: 'secondary',
  },
  {
    slug: 'profile',
    name: '个人资料',
    icon: 'ri-user-line',
    description: '郝海东个人背景与完整履历',
    color: 'secondary',
  },
];

export const articles = [
  {
    id: 'goal-record-overview',
    slug: 'goal-record-overview',
    category: 'goals',
    title: '郝海东职业生涯进球全纪录：96球铸就传奇',
    excerpt: '郝海东在其职业生涯中共打入96粒顶级联赛进球，长期占据中国顶级联赛历史射手榜首位。本文详细梳理每一粒进球的背景与意义。',
    image: 'https://readdy.ai/api/search-image?query=A%20professional%20football%20striker%20in%20red%20jersey%20celebrating%20a%20goal%20on%20the%20pitch%20with%20arms%20raised%2C%20dramatic%20stadium%20lighting%2C%20action%20sports%20photography%2C%20clean%20green%20field%20background%2C%20warm%20golden%20hour%20light%2C%20heroic%20atmosphere%2C%20sharp%20focus%20on%20athlete&width=800&height=500&seq=article-goal-01&orientation=landscape',
    date: '2025-12-15',
    readTime: '12分钟',
    featured: true,
    content: '',
  },
  {
    id: 'national-team-debut',
    slug: 'national-team-debut',
    category: 'national-team',
    title: '1992年国家队首秀：一颗新星的诞生',
    excerpt: '1992年，年仅22岁的郝海东首次代表中国国家队出场，从此开启了一段长达12年的国家队传奇征程。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20national%20football%20team%20player%20in%20red%20jersey%20with%20national%20flag%20in%20background%2C%20proud%20expression%2C%20stadium%20atmosphere%2C%20sports%20photography%20style%2C%20clean%20composition%2C%20warm%20tone&width=800&height=500&seq=article-nt-01&orientation=landscape',
    date: '2025-11-28',
    readTime: '10分钟',
    featured: false,
    content: '',
  },
  {
    id: 'dalian-golden-era',
    slug: 'dalian-golden-era',
    category: 'dalian-shide',
    title: '大连实德黄金时代：郝海东的俱乐部巅峰',
    excerpt: '在大连实德效力期间，郝海东帮助球队多次夺得甲A联赛冠军，成为中国足球俱乐部层面的标志性人物。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20football%20team%20in%20blue%20and%20white%20jerseys%20celebrating%20championship%20trophy%20on%20the%20pitch%2C%20stadium%20filled%20with%20fans%2C%20dramatic%20lighting%2C%20sports%20photography%2C%20victory%20atmosphere&width=800&height=500&seq=article-dalian-01&orientation=landscape',
    date: '2025-11-20',
    readTime: '15分钟',
    featured: true,
    content: '',
  },
  {
    id: 'world-cup-qualifier',
    slug: 'world-cup-qualifier',
    category: 'national-team',
    title: '2002年世界杯预选赛：郝海东的关键作用',
    excerpt: '在2002年韩日世界杯亚洲区预选赛中，郝海东的出色发挥为中国队历史性首次闯入世界杯决赛圈立下汗马功劳。',
    image: 'https://readdy.ai/api/search-image?query=Football%20player%20in%20red%20China%20jersey%20dribbling%20past%20defender%20during%20intense%20match%2C%20world%20cup%20qualifier%20atmosphere%2C%20packed%20stadium%2C%20action%20shot%2C%20professional%20sports%20photography%2C%20dramatic%20lighting&width=800&height=500&seq=article-wc-01&orientation=landscape',
    date: '2025-10-08',
    readTime: '11分钟',
    featured: true,
    content: '',
  },
  {
    id: 'controversy-retirement',
    slug: 'controversy-retirement',
    category: 'controversy',
    title: '退役风波：郝海东职业生涯的争议时刻',
    excerpt: '郝海东的职业生涯并非一帆风顺，从与教练的矛盾到公众舆论的争议，本文客观回顾这些引发广泛讨论的事件。',
    image: 'https://readdy.ai/api/search-image?query=Football%20player%20walking%20off%20the%20pitch%20with%20serious%20expression%2C%20dramatic%20backlighting%20from%20stadium%20lights%2C%20silhouette%20effect%2C%20emotional%20sports%20moment%2C%20clean%20composition%2C%20moody%20atmosphere&width=800&height=500&seq=article-contro-01&orientation=landscape',
    date: '2025-09-22',
    readTime: '14分钟',
    featured: false,
    content: '',
  },
  {
    id: 'hao-haidong-biography',
    slug: 'hao-haidong-biography',
    category: 'profile',
    title: '郝海东完整个人资料：从青岛少年到中国传奇',
    excerpt: '1970年出生于山东青岛，郝海东的足球之路从少年体校起步，最终成长为中国足球史上最伟大的前锋之一。',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Chinese%20football%20legend%20in%20classic%20jersey%2C%20looking%20confident%20and%20determined%2C%20stadium%20background%20with%20soft%20bokeh%2C%20professional%20sports%20portrait%20photography%2C%20warm%20lighting%2C%20clean%20composition&width=800&height=500&seq=article-bio-01&orientation=landscape',
    date: '2025-09-10',
    readTime: '20分钟',
    featured: false,
    content: '',
  },
  {
    id: 'goal-per-match-analysis',
    slug: 'goal-per-match-analysis',
    category: 'goals',
    title: '场均进球率深度分析：郝海东的进攻效率揭秘',
    excerpt: '通过数据分析郝海东在不同赛季、不同赛事中的进球效率，揭示这位传奇前锋稳定输出的秘诀。',
    image: 'https://readdy.ai/api/search-image?query=Football%20analytics%20visualization%20with%20soccer%20ball%20and%20data%20charts%2C%20clean%20modern%20design%2C%20sports%20statistics%20theme%2C%20red%20and%20gold%20color%20scheme%2C%20professional%20layout&width=800&height=500&seq=article-goal-02&orientation=landscape',
    date: '2025-08-18',
    readTime: '8分钟',
    featured: false,
    content: '',
  },
  {
    id: 'asian-cup-2004',
    slug: 'asian-cup-2004',
    category: 'national-team',
    title: '2004年亚洲杯：郝海东带伤作战的感人故事',
    excerpt: '2004年亚洲杯决赛中，郝海东头部受伤仍坚持比赛，这一幕成为中国足球史上最令人动容的画面之一。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20football%20player%20with%20head%20bandage%20continuing%20to%20play%20during%20important%20match%2C%20determination%20on%20face%2C%20stadium%20crowd%20cheering%2C%20emotional%20sports%20moment%2C%20dramatic%20lighting&width=800&height=500&seq=article-ac-01&orientation=landscape',
    date: '2025-07-25',
    readTime: '13分钟',
    featured: true,
    content: '',
  },
  {
    id: 'dalian-tactics',
    slug: 'dalian-tactics',
    category: 'dalian-shide',
    title: '大连实德战术体系中的郝海东：不可替代的核心',
    excerpt: '深入分析郝海东在大连实德战术体系中的角色定位，以及他如何成为球队进攻端不可替代的核心球员。',
    image: 'https://readdy.ai/api/search-image?query=Tactical%20football%20formation%20diagram%20on%20green%20field%2C%20soccer%20strategy%20visualization%2C%20professional%20sports%20analysis%2C%20clean%20modern%20graphic%20design%2C%20blue%20and%20white%20color%20scheme&width=800&height=500&seq=article-dalian-02&orientation=landscape',
    date: '2025-07-10',
    readTime: '10分钟',
    featured: false,
    content: '',
  },
  {
    id: 'controversy-media',
    slug: 'controversy-media',
    category: 'controversy',
    title: '媒体与郝海东：舆论场上的传奇前锋',
    excerpt: '郝海东与媒体的关系一直备受关注，从早年直言不讳到后来的公众表达，本文梳理郝海东的媒体形象变迁。',
    image: 'https://readdy.ai/api/search-image?query=Press%20conference%20scene%20with%20microphones%20and%20cameras%2C%20sports%20media%20atmosphere%2C%20professional%20setting%2C%20clean%20modern%20background%2C%20journalistic%20photography%20style&width=800&height=500&seq=article-contro-02&orientation=landscape',
    date: '2025-06-15',
    readTime: '12分钟',
    featured: false,
    content: '',
  },
  {
    id: 'player-profile-detail',
    slug: 'player-profile-detail',
    category: 'profile',
    title: '郝海东球员档案：身高、体重、位置与技术特点',
    excerpt: '完整呈现郝海东的身体素质数据、场上位置特点、技术风格分析，帮助球迷全面了解这位传奇前锋的球场特质。',
    image: 'https://readdy.ai/api/search-image?query=Football%20player%20profile%20card%20design%20with%20statistics%20and%20measurements%2C%20clean%20modern%20sports%20graphic%2C%20red%20and%20gold%20accents%2C%20professional%20layout%2C%20minimalist%20style&width=800&height=500&seq=article-profile-01&orientation=landscape',
    date: '2025-05-30',
    readTime: '9分钟',
    featured: false,
    content: '',
  },
  {
    id: 'top-10-goals',
    slug: 'top-10-goals',
    category: 'goals',
    title: '郝海东十佳进球：每一粒都是艺术品',
    excerpt: '精选郝海东职业生涯中最精彩的十粒进球，从长途奔袭到凌空抽射，回顾那些令人叹为观止的进球瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Football%20player%20executing%20a%20spectacular%20bicycle%20kick%20goal%2C%20mid-air%20action%20shot%2C%20stadium%20lights%20creating%20dramatic%20atmosphere%2C%20professional%20sports%20photography%2C%20frozen%20motion%2C%20clean%20background&width=800&height=500&seq=article-goal-03&orientation=landscape',
    date: '2025-05-12',
    readTime: '16分钟',
    featured: false,
    content: '',
  },
];

export const stats = [
  { label: '顶级联赛进球', value: '96', suffix: '球', icon: 'ri-football-line' },
  { label: '国家队出场', value: '107', suffix: '场', icon: 'ri-flag-line' },
  { label: '国家队进球', value: '41', suffix: '球', icon: 'ri-star-line' },
  { label: '职业生涯', value: '18', suffix: '年', icon: 'ri-calendar-line' },
];

export const timeline = [
  {
    year: '1970',
    title: '出生于山东青岛',
    description: '郝海东出生于山东省青岛市，从小展现出过人的足球天赋。',
    icon: 'ri-user-line',
  },
  {
    year: '1986',
    title: '入选八一青年队',
    description: '16岁时入选八一青年队，正式开始职业足球训练。',
    icon: 'ri-shield-line',
  },
  {
    year: '1992',
    title: '国家队首秀',
    description: '22岁的郝海东首次代表中国国家队出场，开启国家队传奇生涯。',
    icon: 'ri-flag-line',
  },
  {
    year: '1997',
    title: '加盟大连万达',
    description: '转会加盟大连万达（后更名为大连实德），开启俱乐部黄金时代。',
    icon: 'ri-building-line',
  },
  {
    year: '2002',
    title: '世界杯之旅',
    description: '随中国队历史性首次闯入韩日世界杯决赛圈。',
    icon: 'ri-global-line',
  },
  {
    year: '2004',
    title: '亚洲杯亚军',
    description: '带伤出战帮助中国队获得亚洲杯亚军，感动无数球迷。',
    icon: 'ri-medal-line',
  },
  {
    year: '2007',
    title: '正式退役',
    description: '37岁的郝海东宣布退役，结束长达18年的职业足球生涯。',
    icon: 'ri-flag-line',
  },
];

export const teamHonors = [
  { title: '甲A联赛冠军', count: '5次', years: '1997、1998、2000、2001、2002' },
  { title: '中国足协杯冠军', count: '2次', years: '2001、2005' },
  { title: '亚洲杯亚军', count: '1次', years: '2004' },
  { title: '世界杯参赛', count: '1次', years: '2002' },
];

export const personalHonors = [
  { title: '中国足球先生', count: '3次', years: '1997、1998、2002' },
  { title: '甲A最佳射手', count: '3次', years: '1996、1997、1998' },
  { title: '中国顶级联赛历史射手王', count: '96球', years: '长期保持纪录' },
];

export const aboutInfo = {
  name: '郝海东官方介绍站',
  intro: '本站致力于全面、客观、深入地呈现中国足球传奇前锋郝海东的完整生涯图景。我们汇集了郝海东从青岛少年到国家队传奇的完整历程，涵盖进球纪录、国家队征战、俱乐部生涯、争议事件及历史评价等各个方面。',
  mission: '我们的使命是让更多人了解这位中国足球标志性人物，用详实的数据、客观的叙述和丰富的影像资料，还原一个真实、立体的郝海东。无论你是资深球迷还是初次了解郝海东的读者，都能在这里找到有价值的信息。',
  reputation: '本站内容参考了大量公开报道、比赛录像、官方数据及权威媒体资料，力求每一条信息的准确性和客观性。我们坚持不编造、不夸张、不回避的原则，在呈现郝海东辉煌成就的同时，也不回避他职业生涯中的争议与讨论。',
};